export const UNIT_TYPE_OPTIONS = [
  { value: 'each', label: 'Each', abbr: 'EA' },
  { value: 'square_foot', label: 'Square Foot', abbr: 'SF' },
  { value: 'linear_foot', label: 'Linear Foot', abbr: 'LF' },
  { value: 'hour', label: 'Hour', abbr: 'HR' },
  { value: 'day', label: 'Day', abbr: 'DAY' },
  { value: 'room', label: 'Room', abbr: 'RM' },
  { value: 'fixture', label: 'Fixture', abbr: 'FIX' },
  { value: 'cabinet', label: 'Cabinet', abbr: 'CAB' },
  { value: 'door', label: 'Door', abbr: 'DR' },
  { value: 'window', label: 'Window', abbr: 'WIN' },
  { value: 'bag', label: 'Bag', abbr: 'BAG' },
  { value: 'roll', label: 'Roll', abbr: 'ROLL' },
  { value: 'gallon', label: 'Gallon', abbr: 'GAL' },
  { value: 'roofing_square', label: 'Roofing Square', abbr: 'SQ' },
  { value: 'lump_sum', label: 'Lump Sum', abbr: 'LS' },
  { value: 'other', label: 'Other', abbr: '' },
];

export const unitLabel = (item) => {
  if (!item) return '';
  if (item.unit_type === 'other') return item.custom_unit_label || 'Other';
  const o = UNIT_TYPE_OPTIONS.find((u) => u.value === item.unit_type);
  return o ? o.label : item.unit_type;
};

export const unitAbbr = (item) => {
  if (!item) return '';
  if (item.unit_type === 'other') return item.custom_unit_label || 'unit';
  const o = UNIT_TYPE_OPTIONS.find((u) => u.value === item.unit_type);
  return o?.abbr || o?.label || item.unit_type;
};

export const COST_CLASS_OPTIONS = [
  { value: 'labor', label: 'Labor' },
  { value: 'material', label: 'Material' },
  { value: 'subcontractor', label: 'Subcontractor' },
  { value: 'equipment', label: 'Equipment' },
  { value: 'permit_fee', label: 'Permit / Fee' },
  { value: 'combined', label: 'Combined' },
  { value: 'other', label: 'Other' },
];

export const costClassLabel = (v) => (COST_CLASS_OPTIONS.find((o) => o.value === v) || {}).label || v;

export const PRICING_STATUS_LABELS = {
  complete: 'Priced',
  missing_standard_price: 'No Price Set',
};

export const pricingStatusLabel = (v) => PRICING_STATUS_LABELS[v] || v;

export const PRICING_STATUS_STYLES = {
  complete: 'bg-green-900/40 text-green-400 border-green-800',
  missing_standard_price: 'bg-amber-900/30 text-amber-400 border-amber-800',
};

export const ITEM_SORT_OPTIONS = [
  { value: 'name_az', label: 'Name A–Z' },
  { value: 'recently_updated', label: 'Recently Updated' },
  { value: 'newest', label: 'Newest Added' },
  { value: 'category', label: 'Category' },
  { value: 'standard_high', label: 'Highest Price' },
];

export const ASSEMBLY_SORT_OPTIONS = ITEM_SORT_OPTIONS.slice(0, 4);
